// extracted by mini-css-extract-plugin
export default {"container":"ho-z","ratingLayout":"io-z","ratingLabel":"jo-z","nonInteractiveRatingLabel":"ko-z"};